import PurlResource from '../../Components/PurlResource';
import purlen from './htmlpages/purl.en.js';
import purlfr from './htmlpages/purl.fr.js';
import purles from './htmlpages/purl.es';
import usePurlEn from './htmlpages/usePurl.en';
import usePurlFr from './htmlpages/usePurl.fr';
import usePurlEs from './htmlpages/usePurl.es';
import iccLegalToolsEn from './htmlpages/iccLegalTools.en';
import iccLegalToolsFr from './htmlpages/iccLegalTools.fr';
import iccLegalToolsEs from './htmlpages/iccLegalTools.es';
import tutorialFilmEn from './htmlpages/tutorialFilm.en';
import tutorialFilmFr from './htmlpages/tutorialFilm.fr';
import tutorialFilmEs from './htmlpages/tutorialFilm.es';
import coordinationEn from './htmlpages/coordination.en';
import coordinationFr from './htmlpages/coordination.fr';
import legalToolAdvisoryEn from './htmlpages/ltca.en';
import legalToolAdvisoryEs from './htmlpages/ltca.es';
import legalToolAdvisoryFn from './htmlpages/ltca.fr';
import workToolStatusEN from './htmlpages/workToolStatus.en';
import workToolStatusFr from './htmlpages/workToolStatus.fr';
import workToolStatusEs from './htmlpages/workToolStatus.es';
import projectBackgroundEn from './htmlpages/projectBackground.en';
import projectBackgroundFr from './htmlpages/projectBackground.fr';
import projectBackgroundEs from './htmlpages/projectBackground.es';
import contactUsEn from './htmlpages/contactUs.en';
import contactUsFr from './htmlpages/contactUs.fr';
import contactUsEs from './htmlpages/contactUs.es';
import tableResponsibilitiesEn from './htmlpages/tableResponsibilities.en';
import tableResponsibilitiesEs from './htmlpages/tableResponsibilities.es';
import tableResponsibilitiesFr from './htmlpages/tableResponsibilities.fr';
import termUseEn from './htmlpages/termsUse.en';
import termUseFr from './htmlpages/termUse.fr';
import termUseEs from './htmlpages/termUse.es';
import tutorialFilmRu from './htmlpages/totorialFilm.ru';
import tutorialFilmZh from './htmlpages/tutorialFilm.zh';
import purlZh from './htmlpages/purl.zh';
import purlRu from './htmlpages/purl.ru';
import usePurlZh from './htmlpages/usePurl.zh';
import usePurlRu from './htmlpages/usePurl.ru';
import iccLegalToolsRu from './htmlpages/iccLegalTools.ru';
import iccLegalToolsZh from './htmlpages/iccLegalTools.zh';
import coordinationZh from './htmlpages/coordination.zh';
import coordinationEs from './htmlpages/coordination.es';
import coordinationRu from './htmlpages/coordination.ru';
import legalToolAdvisoryRu from './htmlpages/Itca.ru';
import legalToolAdvisoryZh from './htmlpages/Itca.zh';
import workToolStatusRu from './htmlpages/workToolStatus.ru';
import workToolStatusZh from './htmlpages/workToolStatus.zh';
import termUseRu from './htmlpages/termUse.ru';
import termUseZh from './htmlpages/termUse.zh';
import tableResponsibilitiesZh from './htmlpages/tableResponsibilities.zh';
import tableResponsibilitiesRu from './htmlpages/tableResponsibilities.ru';
import projectBackgroundRu from './htmlpages/projectBackground.ru';
import projectBackgroundZh from './htmlpages/projectBackground.zh';
import contactUsZh from './htmlpages/contactUs.zh';
import contactUsRu from './htmlpages/contactUs.ru';
import lexsitusEn from './htmlpages/lexsitus.en';
import lexsitusFr from './htmlpages/lexsitus.fr';
import lexsitusZh from './htmlpages/lexsitus.zh';
import lexsitusRu from './htmlpages/lexsitus.ru';
import lexsitusEs from './htmlpages/lexsitus.es';
import iDocEn from './htmlpages/idoc.en';
import iDocEs from './htmlpages/idoc.es';
import iDocZh from './htmlpages/idoc.zh';
import iDocRu from './htmlpages/idoc.ru';
import iDocFr from './htmlpages/idoc.fr';

export default {
    '/i-doc': {
        title: 'I-OC',
        'title-en': 'I-DOC',
        'title-fr': 'I-DOC',
        'title-es': 'I-DOC',
        'title-zh': '调查文档处理系统',
        'title-ru': 'Система документации ирасследований(I- DOC)',
        slug: 'i-doc',
        content: iDocEn,
        "content-en": iDocEn,
        "content-fr": iDocFr,
        "content-es": iDocEs,
        "content-zh": iDocZh,
        "content-ru": iDocRu,
    },
    /** Training and contact tutorial */
    '/tutorials': {
        title: 'Tutorial Film',
        'title-en': 'Tutorial Film',
        'title-fr': 'Vidéos tutorielles',
        'title-es': 'Vídeos tutoriales',
        'title-zh': '教学视频',
        'title-ru': 'Обучающие ролики',
        slug: 'tutorials',
        content: tutorialFilmEn,
        'content-en': tutorialFilmEn,
        'content-fr': tutorialFilmFr,
        'content-es': tutorialFilmEs,
        'content-zh': tutorialFilmZh,
        'content-ru': tutorialFilmRu,
    },
    '/purl': {
        title: 'Persistent URLs (PURLs)',
        'title-en': 'URL permanentes (PURL)',
        'title-fr': 'URL persistentes  (PURL)',
        'title-es': 'URL persistentes  (PURL)',
        'title-ru': 'Постоянные URL-адреса (PURL)',
        'title-zh': '永久链接（PURLs）',
        slug: 'purl',
        content: purlen,
        'content-en': purlen,
        'content-fr': purlfr,
        'content-es': purles,
        'content-zh': purlZh,
        'content-ru': purlRu,
    },

    /** How to use purl */
    '/how-to-use-the-purls-in-the-icc-legal-tools-database': {
        title: 'How to use the PURLs in the ICC Legal Tools Database?',
        'title-en': 'Comment se servir des PURL dans la base de données des Outils juridiques de la CPI ?',
        'title-fr': '¿ Cómo utilizar los PURL en la Base de Datos Jurídicos de la CPI ?',
        'title-es': '¿ Cómo utilizar los PURL en la Base de Datos Jurídicos de la CPI ?',
        'title-zh': '如何使用国际刑事法院法律工具数据库中的永久链接',
        'title-ru': 'Как использовать PURL-адреса в базе данных Юридических инструментов МУС?',
        slug: 'how-to-use-the-purls-in-the-icc-legal-tools-database',
        content: usePurlEn,
        'content-en': usePurlEn,
        'content-fr': usePurlFr,
        'content-es': usePurlEs,
        'content-ru': usePurlRu,
        'content-zh': usePurlZh,
    },

    /** What are the ICC Legal Tools? */
    '/what-are-the-icc-legal-tools': {
        title: 'What are the ICC Legal Tools?',
        'title-en': 'What are the ICC Legal Tools?',
        'title-fr': 'Que sont les Outils juridiques de la CPI ?',
        'title-es': '¿Qué son las Herramientas Jurídicas de la CPI? ',
        'title-ru': 'Что такое Юридические инструменты МУС?',
        'title-zh': '国际刑事法院法律工具系统有哪些工具？',
        slug: 'what-are-the-icc-legal-tools',
        content: iccLegalToolsEn,
        'content-en': iccLegalToolsEn,
        'content-fr': iccLegalToolsFr,
        'content-es': iccLegalToolsEs,
        'content-ru': iccLegalToolsRu,
        'content-zh': iccLegalToolsZh,
    },
    //coordination
    '/coordination': {
        title: 'Co-ordination, CMN Fellows, and institutional partners',
        'title-en': 'Co-ordination, CMN Fellows, and institutional partners',
        'title-fr': 'Coordination, membres du CMN et partenaires institutionnels',
        'title-es': 'Coordinación, Becarios de CMN y asociados institucionales ',
        'title-zh': '工作协调、案件矩阵网成员、机构合作者',
        'title-ru': 'Координация, стипендиаты CMN и институциональные партнеры',
        slug: 'coordination',
        content: coordinationEn,
        'content-en': coordinationEn,
        'content-fr': coordinationFr,
        'content-zh': coordinationZh,
        'content-es': coordinationEs,
        'content-ru': coordinationRu,
    },
    //Legal Tools Advisory Committee
    '/status-of-work-on-the-tools/ltac': {
        title: 'LTAC',
        'title-en': 'Legal Tools Advisory Committee',
        'title-fr': 'Comité consultatif sur les Outils juridiques',
        'title-es': 'Comité Asesor sobre Herramientas Jurídicas',
        'title-zh': '法律工具顾问委员会',
        'title-ru': 'Консультативный комитет Юридических инструментов',
        slug: 'ltac',
        content: legalToolAdvisoryEn,
        'content-en': legalToolAdvisoryEn,
        'content-fr': legalToolAdvisoryFn,
        'content-es': legalToolAdvisoryEs,
        'content-ru': legalToolAdvisoryRu,
        'content-zh': legalToolAdvisoryZh,
    },
    /** Status of work on the Tools */
    '/status-of-work-on-the-tools': {
        title: 'Status of work on the Tools',
        'title-en': 'Status of work on the Tools',
        'title-fr': 'État des travaux sur les Outils',
        'title-es': 'Estado del trabajo relacionado con las Herramientas',
        'title-zh': '工具系统现状',
        'title-ru': 'Статус работы над Инструментами',
        slug: 'status-of-work-on-the-tools',
        content: workToolStatusEN,
        'content-en': workToolStatusEN,
        'content-fr': workToolStatusFr,
        'content-es': workToolStatusEs,
        'content-ru': workToolStatusRu,
        'content-zh': workToolStatusZh,
    },
    /** Project background */
    '/background': {
        title: 'Background',
        'title-en': 'Project background',
        'title-fr': 'Historique du projet',
        'title-es': 'Antecedentes del proyecto',
        'title-zh': '项目背景',
        'title-ru': 'История проекта',
        slug: 'background',
        content: projectBackgroundEn,
        'content-en': projectBackgroundEn,
        'content-fr': projectBackgroundFr,
        'content-es': projectBackgroundEs,
        'content-ru': projectBackgroundRu,
        'content-zh': projectBackgroundZh,
    },
    //contact-us
    '/contact-us': {
        title: 'Contact us',
        'title-en': 'Contact us',
        'title-fr': 'Nous contacter',
        'title-es': 'Contáctenos',
        'title-zh': '联系我们',
        'title-ru': 'Связаться с нами',
        slug: 'contact-us',
        content: contactUsEn,
        'content-en': contactUsEn,
        'content-fr': contactUsFr,
        'content-es': contactUsEs,
        'content-zh': contactUsZh,
        'content-ru': contactUsRu,
    },
    /** Responsibilities of each external partner: */
    '/status-of-work-on-the-tools/table-of-responsibilities': {
        title: 'Table of responsibilities',
        'title-en': 'Table of responsibilities',
        'title-fr': 'Responsabilités de chaque partenaire extérieur :',
        'title-es': 'Responsabilidades de cada asociado externo',
        'title-zh': '每个外部合作伙伴负责的工作：',
        'title-ru': 'Обязанности каждого внешнего партнера:',
        slug: 'table-of-responsibilities',
        content: tableResponsibilitiesEn,
        'content-en': tableResponsibilitiesEn,
        'content-fr': tableResponsibilitiesFr,
        'content-es': tableResponsibilitiesEs,
        'content-ru': tableResponsibilitiesRu,
        'content-zh': tableResponsibilitiesZh,
    },

    /** Lexitus page */
    '/lexsitus': {
        title: 'Lexsitus',
        slug: 'lexitus',
        content: lexsitusEn,
        'content-en': lexsitusEn,
        'content-fr': lexsitusFr,
        'content-zh': lexsitusZh,
        'content-ru': lexsitusRu,
        'content-es': lexsitusEs,
    },
    /** Terms of use */
    '/footer/terms-of-use': {
        title: 'Terms of use',
        'title-en': 'Terms of use',
        'title-fr': 'Conditions d’utilisation',
        'title-es': 'Condiciones de uso',
        'title-ru': 'Условия использования',
        'title-zh': '使用条件',
        content: termUseEn,
        'content-en': termUseEn,
        'content-fr': termUseFr,
        'content-es': termUseEs,
        'content-ru': termUseRu,
        'content-zh': termUseZh,
    },
    /** Legal Tools Co-operation Agreements  */
    '/status-of-work-on-the-tools/co-operation-agreements': {
        title: 'Co-operation Agreements',
        slug: 'co-operation-agreements',
        content: `<div id="content" class="content"><div id="breadcrumbs"><p><a href="browse/" >Home&nbsp;»&nbsp;</a><a href="status-of-work-on-the-tools/" >Status of work on the Tools&nbsp;»&nbsp;</a><a href="status-of-work-on-the-tools/co-operation-agreements/" >Co-operation Agreements</a></p></div><div id="getUrlText"><div style="cursor:pointer;float:right;"  title="Collapse tree" id="collapseTree"><i class="glyphicon glyphicon-collapse-down"></i></div> <a href="javascript:window.print();" style="float:right;"><i class="glyphicon glyphicon-print"></i></a></div><br style="clear:both;">
	<!--  CONTENT ELEMENT, uid:180/text [begin] -->
		<div id="c180" class="csc-default">
		<!--  Header: [begin] -->
			<div class="csc-header csc-header-n1"><h1 class="csc-firstHeader">Legal Tools Co-operation Agreements</h1></div>
		<!--  Header: [end] -->
			
		<!--  Text: [begin] -->
			<p class="bodytext">
            Below are some co-operation agreements between the ICC and external partners of the ICC Legal Tools Project. There is natural rotation in the group of partners. Former partners include the Norwegian Centre for Human Rights, the T.M.C. Asser Institute and TRIAL. In recent years, the <a target="_blank" href="https://www.legal-tools.org/cmn-fellows">CMN Fellows</a> have shouldered more of the work to maintain and update the content of the ICC Legal Tools Database. The Co-ordination Team is grateful for the efforts of the external partners and CMN Fellows.
            </p>
		<!--  Text: [end] -->
			</div>
	<!--  CONTENT ELEMENT, uid:180/text [end] -->
		
	<!--  CONTENT ELEMENT, uid:52/uploads [begin] -->
		<div id="c52" class="csc-default">
		<!--  File list: [begin] -->
			<table class="csc-uploads csc-uploads-0"><tbody><tr class="tr-odd tr-first"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/051221_Intention_Agreement_Marburg__countersigned.pdf" target="_blank">051221_Intention_Agreement_Marburg__countersigned.pdf</a></p></td><td class="csc-uploads-fileSize">431 K</td></tr><tr class="tr-even"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/071121_Intention_Agreement_Amendment_Marburg__countersigned.pdf" target="_blank">071121_Intention_Agreement_Amendment_Marburg__countersigned.pdf</a></p></td><td class="csc-uploads-fileSize">1.9 M</td></tr><tr class="tr-odd"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/090720_LT_CA_Korea_University__countersigned_.pdf" target="_blank">090720_LT_CA_Korea_University__countersigned_.pdf</a></p></td><td class="csc-uploads-fileSize">147 K</td></tr><tr class="tr-even"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/090724_LT_CA_Nottingham__countersigned_.pdf" target="_blank">090724_LT_CA_Nottingham__countersigned_.pdf</a></p></td><td class="csc-uploads-fileSize">725 K</td></tr><tr class="tr-odd"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/091217_LT_CA_WRHWLI_countersigned.pdf" target="_blank">091217_LT_CA_WRHWLI_countersigned.pdf</a></p></td><td class="csc-uploads-fileSize">152 K</td></tr><tr class="tr-even"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/100325_LT_CA_Goettingen__countersigned.pdf" target="_blank">100325_LT_CA_Goettingen__countersigned.pdf</a></p></td><td class="csc-uploads-fileSize">1.9 M</td></tr><tr class="tr-odd"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/100531_LT_CA_War_Crimes_Studies_Center__countersigned.pdf" target="_blank">100531_LT_CA_War_Crimes_Studies_Center__countersigned.pdf</a></p></td><td class="csc-uploads-fileSize">241 K</td></tr><tr class="tr-even"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/100921_LT_CA_Salzburg_countersigned.pdf" target="_blank">100921_LT_CA_Salzburg_countersigned.pdf</a></p></td><td class="csc-uploads-fileSize">153 K</td></tr><tr class="tr-odd"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/110117_LT_CA_University_of_Richmond.pdf" target="_blank">110117_LT_CA_University_of_Richmond.pdf</a></p></td><td class="csc-uploads-fileSize">1.4 M</td></tr><tr class="tr-even"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/110610_LT_CA_Canadian_partners.pdf" target="_blank">110610_LT_CA_Canadian_partners.pdf</a></p></td><td class="csc-uploads-fileSize">248 K</td></tr><tr class="tr-odd"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/111017_LT_Co-operation_Agreement_CEEI.pdf" target="_blank">111017_LT_Co-operation_Agreement_CEEI.pdf</a></p></td><td class="csc-uploads-fileSize">218 K</td></tr><tr class="tr-even"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/111025_LT_Co-operation_Agreement_UTDT.pdf" target="_blank">111025_LT_Co-operation_Agreement_UTDT.pdf</a></p></td><td class="csc-uploads-fileSize">280 K</td></tr><tr class="tr-odd"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/140916_Co-operation_Agreement_Jindal_Global_University.pdf" target="_blank">140916_Co-operation_Agreement_Jindal_Global_University.pdf</a></p></td><td class="csc-uploads-fileSize">1.1 M</td></tr><tr class="tr-even"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/150424_LTP_Agreement_Ain_Shams_countersigned.pdf" target="_blank">150424_LTP_Agreement_Ain_Shams_countersigned.pdf</a></p></td><td class="csc-uploads-fileSize">1.4 M</td></tr><tr class="tr-odd"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/150513_Agreement_UKZN-UCT__countersigned.pdf" target="_blank">150513_Agreement_UKZN-UCT__countersigned.pdf</a></p></td><td class="csc-uploads-fileSize">1.6 M</td></tr><tr class="tr-even"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/150724_Aoyama_Gakuin_LTP_Agreement__countersigned.pdf" target="_blank">150724_Aoyama_Gakuin_LTP_Agreement__countersigned.pdf</a></p></td><td class="csc-uploads-fileSize">1.4 M</td></tr><tr class="tr-odd"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/150918_LT_CA_Nottingham.pdf" target="_blank">150918_LT_CA_Nottingham.pdf</a></p></td><td class="csc-uploads-fileSize">2.0 M</td></tr><tr class="tr-even"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/150918_LT_CA_Stanford_University.pdf" target="_blank">150918_LT_CA_Stanford_University.pdf</a></p></td><td class="csc-uploads-fileSize">1.3 M</td></tr><tr class="tr-odd"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/150921_LT_CA_NUS_Faculty_of_Law.pdf" target="_blank">150921_LT_CA_NUS_Faculty_of_Law.pdf</a></p></td><td class="csc-uploads-fileSize">501 K</td></tr><tr class="tr-even"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/151007_LT_CA_PKU_Law_School__countersigned.pdf" target="_blank">151007_LT_CA_PKU_Law_School__countersigned.pdf</a></p></td><td class="csc-uploads-fileSize">1.5 M</td></tr><tr class="tr-odd"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/151019_LT_CA_Canadian_partners__countersigned.pdf" target="_blank">151019_LT_CA_Canadian_partners__countersigned.pdf</a></p></td><td class="csc-uploads-fileSize">1.8 M</td></tr><tr class="tr-even"><td class="csc-uploads-fileName"><p><a href="https://ltd-docs.s3.eu-central-1.amazonaws.com/media/151019_LT_CA_ULB.pdf" target="_blank">151019_LT_CA_ULB.pdf</a></p></td><td class="csc-uploads-fileSize">1.5 M</td></tr></tbody></table>
		<!--  File list: [end] -->
			</div>
	<!--  CONTENT ELEMENT, uid:52/uploads [end] -->
        </div>`,
    },

    /** Legal Tools Expert Advisory Group */
    '/status-of-work-on-the-tools/lteag': {
        title: 'LTEAG',
        slug: 'lteag',
        content: `<div id="content" class="content"><div id="breadcrumbs"><p><a href="browse/" >Home&nbsp;»&nbsp;</a><a href="status-of-work-on-the-tools/" >Status of work on the Tools&nbsp;»&nbsp;</a><a href="status-of-work-on-the-tools/lteag/" >LTEAG</a></p></div><div id="getUrlText"><div style="cursor:pointer;float:right;"  title="Collapse tree" id="collapseTree"><i class="glyphicon glyphicon-collapse-down"></i></div> <a href="javascript:window.print();" style="float:right;"><i class="glyphicon glyphicon-print"></i></a></div><br style="clear:both;">
	<!--  CONTENT ELEMENT, uid:257/text [begin] -->
		<div id="c257" class="csc-default">
		<!--  Header: [begin] -->
			<div class="csc-header csc-header-n1"><h1 class="csc-firstHeader">Legal Tools Expert Advisory Group</h1></div>
		<!--  Header: [end] -->
			
		<!--  Text: [begin] -->
			<p class="bodytext">An ICC Legal Tools Expert Advisory Group (the LTEAG) has been established with leading legal informatics&nbsp;experts to serve as an advisory and sounding board for the further technical and strategic development of the Legal Tools. The members of the Group are: Professor <a href="http://www.cilrap.org/bergsmo/" target="_blank">Morten Bergsmo</a> (Norway); Professor <a href="http://herberger.jura.uni-sb.de/herberger/" target="_blank">Maximilian Herberger</a>, University of Saarland (Germany); Professor <a href="https://www.ou.nl/web/over-ons/uitgebreid-cv-Anja-Oskamp" target="_blank">Anja Oskamp</a>, Free University Amsterdam (the Netherlands); Professor <a href="http://iis.gu.se/english/contact/more-about-ulf-petrusson" target="_blank">Ulf Petrusson</a> (University of Gothenburg); Professor <a href="http://people.cs.kuleuven.be/~sien.moens/" target="_blank">Marie-Francine (Sien) Moens</a>, Catholic University Leuven (Belgium); Professor Richard V. De Mulder, Erasmus University Rotterdam (the Netherlands); and Professor <a href="http://www.eui.eu/DepartmentsAndCentres/Law/People/Professors/Sartor.aspx" target="_blank">Giovanni Sartor</a>, European University Institute (Italy). The late Professor<a href="https://en.wikipedia.org/wiki/Jon_Bing" target="_blank"> Jon Bing</a> was the first Chair of the Group. The inaugural meeting of the Group took place at the interim seat of the Court on 7 December 2005.</p>
		<!--  Text: [end] -->
			</div>
	<!--  CONTENT ELEMENT, uid:257/text [end] -->
        </div>`,
    },

    /** Training and contact */
    '/training-and-contact': {
        title: 'Training and contact',
        slug: 'training-and-contact',
        content: `<div id="content" class="content"><div id="breadcrumbs"><p><a href="browse/" >Home&nbsp;»&nbsp;</a><a href="training-and-contact/" >Training and contact</a></p></div><div id="getUrlText"><div style="cursor:pointer;float:right;"  title="Collapse tree" id="collapseTree"><i class="glyphicon glyphicon-collapse-down"></i></div> <a href="javascript:window.print();" style="float:right;"><i class="glyphicon glyphicon-print"></i></a></div><br style="clear:both;">
	<!--  CONTENT ELEMENT, uid:146/text [begin] -->
		<div id="c146" class="csc-default">
		<!--  Header: [begin] -->
			<div class="csc-header csc-header-n1"><h1 class="csc-firstHeader">Training</h1></div>
		<!--  Header: [end] -->
			
		<!--  Text: [begin] -->
			<p class="bodytext">The Legal Tools are easy to use and are freely available online. All users have access to the films below. Institutions that need training for a group of individual users of the Legal Tools can send a request to <a href="mailto:info@cilrap.org">info@cilrap.org</a> or <a href="mailto:bais@cilrap.org">bais@cilrap.org</a> (<a href="http://www.cilrap.org/bais/" target="_blank">Devasheesh Bais</a> is Deputy Co-ordinator of the Legal Tools Project).
		<!--  Text: [end] -->
			</div>
	<!--  CONTENT ELEMENT, uid:146/text [end] -->
		
	<!--  CONTENT ELEMENT, uid:149/textpic [begin] -->
		<div id="c149" class="csc-default">
		<!--  Image block: [begin] -->
			<div class="csc-textpic-text">
		<!--  Text: [begin] -->
			<ul>
            <li><a href="https://www.cilrap.org/cilrap-film/210915-ltd-cld-lexsitus/" target="_blank">Presentation of the LTD, CLD and Lexsitus to ICC Counsel</a></li>
            <li><a href="https://www.legal-tools.org/training-and-contact/tutorial-film/" target="_blank">Tutorial film on the ICC Legal Tools Database</a></li>
            </ul>
		<!--  Text: [end] -->
			</div>
		<!--  Image block: [end] -->
			</div>
	<!--  CONTENT ELEMENT, uid:149/textpic [end] -->
		
	<!--  CONTENT ELEMENT, uid:259/text [begin] -->
		<div id="c259" class="csc-default">
		<!--  Text: [begin] -->
			<p class="bodytext">Please use one of the working languages of the Court - English or French - for any correspondence. The personal information you provide in your communications pursuant to or by reason of the Legal Tools Project will be used for internal statistical purposes only. Personal information will not be distributed outside the ICC and its external partners. Please read our privacy policy <a href="footer/terms-of-use/">here</a>.</p>
		<!--  Text: [end] -->
			</div>
	<!--  CONTENT ELEMENT, uid:259/text [end] -->
        </div>`,
    },

    '/comments-and-contributions-backup': {
        title: 'Comments and contributions',
        content: `<div id="content" class="content"><div id="breadcrumbs"><p><a href="browse/" >Home&nbsp;»&nbsp;</a><a href="training-and-contact/" >Training and contact&nbsp;»&nbsp;</a><a href="training-and-contact/comments-and-contributions/" >Comments and contributions</a></p></div><div id="getUrlText"><div style="cursor:pointer;float:right;"  title="Collapse tree" id="collapseTree"><i class="glyphicon glyphicon-collapse-down"></i></div> <a href="javascript:window.print();" style="float:right;"><i class="glyphicon glyphicon-print"></i></a></div><br style="clear:both;">
	<!--  CONTENT ELEMENT, uid:14/text [begin] -->
		<div id="c14" class="csc-default">
		<!--  Header: [begin] -->
			<div class="csc-header csc-header-n1"><h1 class="csc-firstHeader">Comments and contributions</h1></div>
		<!--  Header: [end] -->
			
		<!--  Text: [begin] -->
			<p class="bodytext">Please address your queries and suggestions on the Legal Tools to <a href="mailto:info@cilrap.org" title="Opens external link in new window" class="external-link-new-window">info@cilrap.org</a>&nbsp;with the subject "Questions" or "Comments" and indicate the Tool(s) on which&nbsp;you would like to comment. Please send any material you think relevant to the Legal Tools to the same e-mail address, with the subject "Contribution&nbsp;to the Legal Tools" and indicate to which Tool(s) the submitted material pertains. </p>
		<!--  Text: [end] -->
			</div>
	<!--  CONTENT ELEMENT, uid:14/text [end] -->
        </div>`,
    },

    /** National Implementing Legislation Database */
    '/national-implementing-legislation-database': {
        title: 'National Implementing Legislation Database',
        content: `<div id="content" class="content"><div id="breadcrumbs"><p><a href="browse/" >Home&nbsp;»&nbsp;</a><a href="browse/" >Browse&nbsp;»&nbsp;</a><a href="browse/national-implementing-legislation-database/" >National Implementing Legislation Database</a></p></div><div id="getUrlText"><div style="cursor:pointer;float:right;"  title="Collapse tree" id="collapseTree"><i class="glyphicon glyphicon-collapse-down"></i></div> <a href="javascript:window.print();" style="float:right;"><i class="glyphicon glyphicon-print"></i></a></div><br style="clear:both;">
	<!--  CONTENT ELEMENT, uid:61/list [begin] -->
		<div id="c61" class="csc-default">
		<!--  Header: [begin] -->
			<div class="csc-header csc-header-n1"><h1 class="csc-firstHeader">National Implementing Legislation Database</h1></div>
		<!--  Header: [end] -->
			
		<!--  Plugin inserted: [begin] -->
			


	<!--

		BEGIN: Content of extension "longiframe", plugin "tx_longiframe_pi1"

	-->
	<div class="tx-longiframe-pi1">
		<iframe src="https://iccdb.hrlc.net/data/" height="1000px" width="100%" name="frame" id="frame" frameborder="0" scrolling="auto"></iframe>
	</div>
	
	<!-- END: Content of extension "longiframe", plugin "tx_longiframe_pi1" -->

	
		<!--  Plugin inserted: [end] -->
			</div>
	<!--  CONTENT ELEMENT, uid:61/list [end] -->
        </div>`,
    },

    '/cmn-fellows': {
        title: 'CMN Fellows',
        slug: 'cmn-fellows',
        content: `<div id="content" class="content"><div id="breadcrumbs"><p><a href="browse/" >Home&nbsp;»&nbsp;</a><a href="status-of-work-on-the-tools/" >
		Status of work on the Tools&nbsp;»&nbsp;</a><a href="status-of-work-on-the-tools/background/" >Background</a></p></div><div id="getUrlText"><div style="cursor:pointer;float:right;"  title="Collapse tree" id="collapseTree"><i class="glyphicon glyphicon-collapse-down"></i></div> <a href="javascript:window.print();" style="float:right;"><i class="glyphicon glyphicon-print"></i></a></div><br style="clear:both;">
	<!--  CONTENT ELEMENT, uid:258/text [begin] -->
		<div id="c258" class="csc-default">
		<!--  Header: [begin] -->
			<div class="csc-header csc-header-n1"><h1 class="csc-firstHeader">CMN Fellows</h1></div>
		<!--  Header: [end] -->			
		<!--  Text: [begin] -->
			<p  class="bodytext">The content-update and maintenance work on the ICC Legal Tools Database (LTD) is undertaken by a group of CMN Fellows under the guidance of the LTD Co-ordination Team, as part of a <i>pro bono</i> contribution of CILRAP towards the LTD as a digital public good. CMN Fellows are a diverse group of individuals who contribute to the LTD on a longer-term basis, and in the spirit of public-interest service. A list of current and former CMN Fellows is available <a id="_anchor_1" href="https://www.casematrixnetwork.org/about-us/cmn-fellows/" target="_blank">here </a> </p>
            <p  class="bodytext">Those interested in contributing as a CMN Fellow may send an e-mail message with an updated <i>curriculum vitae</i> to info@cilrap.org. Candidates are selected on the basis of a) precision, b) motivation to have an ongoing involvement, and c) interest in knowledge-transfer and capacity development.</p>
		<!--  Text: [end] -->
			</div>
	<!--  CONTENT ELEMENT, uid:258/text [end] -->
        </div>`,
    },
};
